import React, { useState } from "react";
import Title from "../Title/Title";
import "./Project.css";
import { projectDatas } from "../../projects";
import ProjectCard from "../ProjectCard/ProjectCard";

const Project = () => {
  const [projects, setProjects] = useState(projectDatas);
  const [search, setSearch] = useState("");

  return (
    <>
      <div className="mb-9"></div>
      <Title title="List of Projects" />
      <Title title="60+ Github project repositories" />
      <Title
        title={`${projects.length} projects with frontend and backend connectivity`}
      />
      <div className="mb-4"></div>
      <div className="searchInputBox">
        <input
          type="text"
          id="search"
          className="searchInput"
          onChange={(e) => setSearch(e.target.value)}
          placeholder=" 🔍 React js/Angular js/Nest js/Vue js/Next js projects"
        />
      </div>
      <div className="mb-4"></div>
      <section className="project-container">
        <div className="card-project">
          {projects
            .filter((val) => {
              if (search === "") {
                return val;
              } else if (
                val.framework.toLowerCase().includes(search.toLowerCase())
              ) {
                return val;
              }
            })
            .map((p, index) => {
              return <ProjectCard key={p.id} p={p} />;
            })}
        </div>
      </section>
    </>
  );
};

export default Project;
